module.exports = __webpack_public_path__ + "static/media/sash-window.88a5707c.obj";